import { KubraLogin } from '@models/kubra-login';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { ServiceHelpersService } from '../../_helpers/service-helpers.service';
import { AgentNotificationService } from '../agent/agent-notification.service';

@Injectable({
  providedIn: 'root',
})
export class PaperlessService {
  firstTime= false;
  snooze= false;
  displayBanner = false;
  displayPopup: boolean = null;
  eligiblePolicies: any = [];

  private messageSource = new BehaviorSubject<boolean>(this.firstTime);
  $firstTime = this.messageSource.asObservable();

  private snoozeMessageSource = new BehaviorSubject<boolean>(this.snooze);
  $snooze = this.snoozeMessageSource.asObservable();

  private displayBannerSource = new BehaviorSubject<boolean>(
    this.displayBanner
  );
  $displayBanner = this.displayBannerSource.asObservable();

  private displayPopupSource = new Subject<boolean>();
  $displayPopup = this.displayPopupSource.asObservable();

  private eligiblePoliciesSource = new BehaviorSubject<string[]>(
    this.eligiblePolicies
  );
  $eligiblePolicies = this.eligiblePoliciesSource.asObservable();

  currentRoute: any;

  constructor(
    private http: HttpClient,
    private serviceHelpers: ServiceHelpersService,
    private agentNotification: AgentNotificationService
  ) {}

  cancelPaperlessEPolicyV2(policyid, email): Observable<any> {
    void policyid;
    void email;
    const url = `${environment.backend_server_url_policy}/v2/paperless-unenrollment`;
    return this.http.post(
      url,
      this.agentNotification.getHeader(),
      this.serviceHelpers.options
    );
  }

  cancelPaperlessEPayOld(policyid, email): Observable<any> {
    const policyEmail: any = {
      address: email,
      policyNumber: policyid,
      agentEmail: this.agentNotification.agentInfo.agentEmail,
      agentCode: this.agentNotification.agentInfo.agentCode,
      agentName: this.agentNotification.agentInfo.agentName,
      insuredName: this.agentNotification.agentInfo.insuredName,
    };
    const url = `${environment.backend_server_url_billing}/v2/unenroll-eft`;
    return this.http.post(url, policyEmail, this.serviceHelpers.options);
  }

  cancelPaperlessEBill(policyid, email): Observable<any> {
    const url = `${environment.backend_server_url_policy}/${email}/${policyid}/ebill-unenrollment`;
    return this.http.post(url, {}, this.serviceHelpers.options);
  }

  enrollPaperlessEPolicyV2(policyid, email): Observable<any> {
    void policyid;
    void email;
    const url = `${environment.backend_server_url_policy}/v2/paperless-enrollment`;
    return this.http.post(
      url,
      this.agentNotification.getHeader(),
      this.serviceHelpers.options
    );
  }

  enrollPaperlessEPay(policyid, formData, email): Observable<any> {
    const policyEmail: any = {
      address: email,
      policyNumber: policyid,
      agentEmail: this.agentNotification.agentInfo.agentEmail,
      agentCode: this.agentNotification.agentInfo.agentCode,
      agentName: this.agentNotification.agentInfo.agentName,
      insuredName: this.agentNotification.agentInfo.insuredName,
    };
    formData.policyEmail = policyEmail;
    const url = `${environment.backend_server_url_billing}/v2/enroll-eft`;
    return this.http.post(url, formData, this.serviceHelpers.options);
  }

  enrollPaperlessEBill(policyid, email): Observable<any> {
    const url = `${environment.backend_server_url_policy}/${email}/${policyid}/ebill-enrollment`;
    return this.http.post(url, {}, this.serviceHelpers.options);
  }

  // --- other paperless methods
  updatePaperlessEPay(policyid, formData, email): Observable<any> {
    const policyEmail: any = {
      address: email,
      policyNumber: policyid,
      agentEmail: this.agentNotification.agentInfo.agentEmail,
      agentCode: this.agentNotification.agentInfo.agentCode,
      agentName: this.agentNotification.agentInfo.agentName,
      insuredName: this.agentNotification.agentInfo.insuredName,
    };
    formData.policyEmail = policyEmail;
    const url = `${environment.backend_server_url_billing}/v2/update-eft`;
    return this.http.post(url, formData, this.serviceHelpers.options);
  }

  // --- autopay methods
  enrollPaperlessEPayV2( policyDetails, formData, email ): Observable<any> {    
    formData.eftPolicy = this.buildEftPolicy(policyDetails, email);
    const url =               `${environment.backend_server_url_billing}/v2/enroll-eft`;
    return this.http.post(url, formData, this.serviceHelpers.options );
  }

  updatePaperlessEPayV2( policyDetails, formData, email ): Observable<any> {
    formData.eftPolicy = this.buildEftPolicy(policyDetails, email);

    const url =               `${environment.backend_server_url_billing}/v2/update-eft`;
    return this.http.post(url, formData, this.serviceHelpers.options );
  }

  cancelPaperlessEPay( policyDetails, email ): Observable<any> {
    const eftPolicy = this.buildEftPolicy(policyDetails, email);
    const url =               `${environment.backend_server_url_billing}/v2/unenroll-eft`;
    return this.http.post(url, eftPolicy, this.serviceHelpers.options );
  }

  buildEftPolicy( policyDetails, email ): any {
    const insuredName = policyDetails.insured.find(x => x.isPrimaryInsured)

    return {
      address: email,
      policyNumber: policyDetails.policynumber.policyNumber,
      companyCode: policyDetails.company?.companyId,
      policyNames: (policyDetails.policyNames) ? policyDetails.policyNames : [],
      agentName: policyDetails.agent?.agentName ? policyDetails.agent?.agentName : "",
      agentEmail: policyDetails.agent?.agentEmail ? policyDetails.agent?.agentEmail : "",
      agentPhoneNumber: policyDetails.agent?.agentPhone?.number ? policyDetails.agent?.agentPhone?.number : "",
      agentCode: policyDetails.agent?.agentCode?.code ? policyDetails.agent?.agentCode?.code : "",   
      insuredName:  {
        firstName: insuredName.firstName,
        middleName: insuredName.middleName ? insuredName.middleName : "",
        lastName: insuredName.lastName ? insuredName.lastName : ""
      }      
    };
    // formData.policyEmail = policyEmail;
    // const url = `${environment.backend_server_url_billing}/v2/update-eft`;
    // return this.http.post(url, formData, this.serviceHelpers.options);
  }

  viewEBILL(email): Observable<KubraLogin> {
    const url = `${environment.backend_server_url_policy}/${email}/view-ebills`;
    return this.http.post(url, {}, this.serviceHelpers.options);
  }

  snoozePaperless(email) {
    const url = `${environment.backend_server_url_account}/${email}/snooze-paperless`;
    return this.http.patch(url, {}, this.serviceHelpers.options);
  }

  snoozePaperlessPopup(email, policyNumbers) {
    const url = `${environment.backend_server_url_account}/${email}/paperlesspopup-snooze`;
    return this.http.post(url, policyNumbers, this.serviceHelpers.options);
  }

  canRemindPaperless(email) {
    const url = `${environment.backend_server_url_account}/${email}/can-remind-paperless`;
    return this.http.get(url);
  }

  getAppBanner(email) {
    const url = `${environment.backend_server_url_account}/app-banner/${email}`;
    return this.http.get(url);
  }

  updateAppBanner(email, isAppBanner) {
    const url = `${environment.backend_server_url_account}/update-app-banner/${email}`;
    return this.http.post(url, { isAvailable: isAppBanner });
  }

  checkIfEnrolledInEPay(userData): boolean {
    void userData;
    return false;
  }

  updatePaperlessFirstTime(firsttime: boolean) {
    this.messageSource.next(firsttime);
  }

  UpdatePaperlessOnSnooze(snooze: boolean) {
    this.snoozeMessageSource.next(snooze);
  }

  togglePaperlessBanner(displayBanner: boolean) {
    this.displayBannerSource.next(displayBanner);
  }

  togglePaperlessPopup(displayPopup: boolean) {
    this.displayPopupSource.next(displayPopup);
  }

  updateEligiblePolicies(eligiblePolicies) {
    this.eligiblePoliciesSource.next(eligiblePolicies);
  }

  setCurrentRoute(route) {
    this.currentRoute = route;
  }

  getCurrentRoute() {
    return this.currentRoute;
  }
  clearPaperlessPopup() {
    this.displayPopupSource.next(null);
  }
}
